import "./index.css";
import Onboard from "./Onboard";
import { useState, useEffect, useCallback, useRef } from "react";

// ─── ICONS (inline SVG for reliability) ──────────
const Icon = ({d,size=20,color="currentColor"}) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d={d}/></svg>;
const I = {
  home:"M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z M9 22V12h6v10",
  search:"M21 21l-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0z",
  users:"M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2 M23 21v-2a4 4 0 0 0-3-3.87 M9 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0z M16 3.13a4 4 0 0 1 0 7.75",
  star:"M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z",
  user:"M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2 M12 7a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
  bell:"M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9 M13.73 21a2 2 0 0 1-3.46 0",
  plus:"M12 5v14 M5 12h14",
  check:"M20 6L9 17l-5-5",
  chevR:"M9 18l6-6-6-6",
  chevD:"M6 9l6 6 6-6",
  back:"M19 12H5 M12 19l-7-7 7-7",
  target:"M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12z M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
  award:"M12 15l-3 9 3-2 3 2-3-9 M8.21 13.89L7 23l5-3 5 3-1.21-9.12 M12 2a7 7 0 1 0 0 14 7 7 0 0 0 0-14z",
  brief:"M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16",
  book:"M4 19.5A2.5 2.5 0 0 1 6.5 17H20 M4 4.5A2.5 2.5 0 0 1 6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5z",
  clock:"M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 6v6l4 2",
  heart:"M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z",
  map:"M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z M12 7a3 3 0 1 0 0 6 3 3 0 0 0 0-6z",
  trending:"M23 6l-9.5 9.5-5-5L1 18",
  gift:"M20 12v10H4V12 M2 7h20v5H2z M12 22V7 M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z",
  edit:"M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7 M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z",
  trash:"M3 6h18 M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
  upload:"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4 M17 8l-5-5-5 5 M12 3v12",
  x:"M18 6L6 18 M6 6l12 12",
  wifi:"M1 1l22 22 M16.72 11.06A10.94 10.94 0 0 1 19 12.55 M5 12.55a10.94 10.94 0 0 1 5.17-2.39",
  monitor:"M2 3h20v14H2z M8 21h8 M12 17v4",
  send:"M22 2L11 13 M22 2l-7 20-4-9-9-4 20-7z",
  log:"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6 M16 13H8 M16 17H8 M10 9H8",
};

// ─── THEME ───────────────────────────────────────
const T = {
  blue:"#0052CC",dk:"#0B1D3A",teal:"#00A89D",orange:"#FF6B35",
  bg:"#F5F7FA",white:"#FFFFFF",border:"#E4E9F0",muted:"#6B7B8D",
  green:"#22C55E",red:"#EF4444",gold:"#FFCC00",purple:"#7C3AED",
};

// ─── STORAGE HELPERS ─────────────────────────────
const S = {
  async get(k){try{const v=localStorage.getItem("sc_"+k);return v?JSON.parse(v):null}catch{return null}},
  async set(k,v){try{localStorage.setItem("sc_"+k,JSON.stringify(v));return true}catch{return false}},
  async del(k){try{localStorage.removeItem("sc_"+k)}catch{}},
};

// ─── ID GENERATOR ────────────────────────────────
const uid = () => Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
const today = () => new Date().toISOString().slice(0, 10);
const fmtDate = (d) => new Date(d).toLocaleDateString("en-NG", { month: "short", day: "numeric", year: "numeric" });

// ─── DEFAULT DATA ────────────────────────────────
const DEFAULT_USER = {
  id: uid(), name: "", username: "", location: "", score: 0, rank: "Newcomer",
  totalPoints: 0, goalsCompleted: 0, circlesJoined: 0, peopleMentored: 0,
  hoursInvested: 0, skills: [], joined: today(), lastCheckIn: null, streak: 0,
  checkInHistory: [],
};

const RANK_THRESHOLDS = [
  [0, "Newcomer"], [100, "Rising Star"], [300, "Consistent Learner"],
  [500, "Growth Champion"], [720, "Solid Achiever"], [1000, "Elite Performer"],
  [1500, "Community Leader"], [2500, "Master Builder"],
];

const getRank = (score) => {
  let rank = "Newcomer";
  for (const [threshold, name] of RANK_THRESHOLDS) { if (score >= threshold) rank = name; }
  return rank;
};

const SAMPLE_OPPORTUNITIES = [
  { id: "opp1", title: "UI/UX Design Intern", company: "Tugeddah Sports", location: "Lagos", type: "Internship", posted: "2026-06-10" },
  { id: "opp2", title: "Data Analyst Intern", company: "FintechPay", location: "Remote", type: "Internship", posted: "2026-06-09" },
  { id: "opp3", title: "Community Manager", company: "Zuri Team", location: "Lagos", type: "Job", posted: "2026-06-08" },
  { id: "opp4", title: "Frontend Developer", company: "PayStack", location: "Remote", type: "Job", posted: "2026-06-07" },
  { id: "opp5", title: "Google Africa Scholarship", company: "Google", location: "Remote", type: "Scholarship", posted: "2026-06-06" },
];

const SAMPLE_STUDY_BARS = [
  { id: "sb1", name: "Umuahia Central Study Bar", access: "24/7", distance: "0.8km", amenities: ["WiFi", "Power", "Laptops", "Coffee"] },
  { id: "sb2", name: "Aba Tech Hub", access: "24/7", distance: "1.5km", amenities: ["WiFi", "Power", "Quiet Rooms"] },
  { id: "sb3", name: "Umuahia Innovation Centre", access: "8AM-10PM", distance: "2.1km", amenities: ["WiFi", "Power", "Meeting Rooms"] },
];

const REWARDS_CATALOG = [
  { id: "r1", name: "Airtime (₦500)", cost: 500, icon: "📱", category: "Data & Airtime" },
  { id: "r2", name: "Data Bundle (1GB)", cost: 800, icon: "📶", category: "Data & Airtime" },
  { id: "r3", name: "Study Bar Day Pass", cost: 1000, icon: "🏢", category: "Access" },
  { id: "r4", name: "Event Access", cost: 750, icon: "🎫", category: "Access" },
  { id: "r5", name: "Scholarship Draw Entry", cost: 1500, icon: "🎓", category: "Career" },
  { id: "r6", name: "Resume Review", cost: 600, icon: "📝", category: "Career" },
  { id: "r7", name: "1-on-1 Coaching (30min)", cost: 2000, icon: "🎯", category: "Career" },
];

// ─── SMALL COMPONENTS ────────────────────────────
function Avatar({ initials, size = 40, bg = T.blue }) {
  return <div style={{ width: size, height: size, borderRadius: "50%", background: bg, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 700, fontSize: size * 0.35, flexShrink: 0, letterSpacing: 0.5 }}>{initials}</div>;
}

function ProgressBar({ value, color = T.teal, h = 6 }) {
  return <div style={{ width: "100%", height: h, background: "#E8EDF2", borderRadius: h }}><div style={{ width: `${Math.min(100, value)}%`, height: "100%", background: color, borderRadius: h, transition: "width 0.4s" }} /></div>;
}

function Badge({ text, color = T.teal }) {
  return <span style={{ background: color, color: "#fff", padding: "3px 10px", borderRadius: 12, fontSize: 11, fontWeight: 600 }}>{text}</span>;
}

function Card({ children, onClick, style = {} }) {
  return <div onClick={onClick} style={{ background: T.white, borderRadius: 14, padding: 16, marginBottom: 12, boxShadow: "0 1px 4px rgba(0,0,0,0.06)", cursor: onClick ? "pointer" : "default", ...style }}>{children}</div>;
}

function Btn({ children, onClick, color = T.blue, outline, full, small, disabled, style = {} }) {
  return <button disabled={disabled} onClick={onClick} style={{ background: outline ? "transparent" : color, color: outline ? color : "#fff", border: outline ? `2px solid ${color}` : "none", borderRadius: 10, padding: small ? "8px 16px" : "12px 24px", fontWeight: 600, cursor: disabled ? "not-allowed" : "pointer", width: full ? "100%" : "auto", fontSize: small ? 13 : 15, opacity: disabled ? 0.5 : 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 6, ...style }}>{children}</button>;
}

function Input({ label, value, onChange, placeholder, type = "text", textarea }) {
  const shared = { width: "100%", padding: "10px 14px", border: `1px solid ${T.border}`, borderRadius: 10, fontSize: 14, outline: "none", fontFamily: "inherit", boxSizing: "border-box" };
  return <div style={{ marginBottom: 14 }}>
    {label && <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: T.dk, marginBottom: 5 }}>{label}</label>}
    {textarea ? <textarea value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} rows={3} style={{ ...shared, resize: "vertical" }} /> :
      <input type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} style={shared} />}
  </div>;
}

function TabBar({ tabs, active, onChange }) {
  return <div style={{ display: "flex", borderBottom: `2px solid ${T.border}`, background: T.white, overflowX: "auto" }}>
    {tabs.map(t => <button key={t} onClick={() => onChange(t)} style={{ padding: "10px 16px", border: "none", borderBottom: active === t ? `2px solid ${T.blue}` : "2px solid transparent", background: "none", cursor: "pointer", fontWeight: active === t ? 600 : 400, color: active === t ? T.blue : T.muted, fontSize: 13, marginBottom: -2, whiteSpace: "nowrap" }}>{t}</button>)}
  </div>;
}

function Header({ title, onBack, right }) {
  return <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", borderBottom: `1px solid ${T.border}`, background: T.white, position: "sticky", top: 0, zIndex: 10 }}>
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      {onBack && <button onClick={onBack} style={{ background: "none", border: "none", cursor: "pointer", padding: 4 }}><Icon d={I.back} size={20} color={T.dk} /></button>}
      <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: T.dk }}>{title}</h2>
    </div>
    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>{right}</div>
  </div>;
}

function Empty({ icon, title, desc, action, onAction }) {
  return <div style={{ textAlign: "center", padding: "40px 24px" }}>
    <div style={{ fontSize: 40, marginBottom: 12 }}>{icon}</div>
    <h3 style={{ margin: "0 0 6px", color: T.dk, fontSize: 16 }}>{title}</h3>
    <p style={{ color: T.muted, fontSize: 13, margin: "0 0 16px" }}>{desc}</p>
    {action && <Btn onClick={onAction} small>{action}</Btn>}
  </div>;
}

function Modal({ open, onClose, title, children }) {
  if (!open) return null;
  return <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 200, display: "flex", alignItems: "flex-end", justifyContent: "center" }} onClick={onClose}>
    <div onClick={e => e.stopPropagation()} style={{ background: T.white, borderRadius: "20px 20px 0 0", width: "100%", maxWidth: 430, maxHeight: "85vh", overflow: "auto", padding: "20px 16px 32px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: T.dk }}>{title}</h3>
        <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer" }}><Icon d={I.x} size={22} color={T.muted} /></button>
      </div>
      {children}
    </div>
  </div>;
}

function Toast({ message, type = "success" }) {
  if (!message) return null;
  const colors = { success: T.green, error: T.red, info: T.blue };
  return <div style={{ position: "fixed", top: 40, left: "50%", transform: "translateX(-50%)", background: colors[type], color: "#fff", padding: "10px 24px", borderRadius: 10, fontSize: 14, fontWeight: 600, zIndex: 300, boxShadow: "0 4px 12px rgba(0,0,0,0.2)", maxWidth: 360, textAlign: "center" }}>{message}</div>;
}

// ─── MAIN APP ────────────────────────────────────
export default function App() {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [screen, setScreen] = useState("home");
  const [nav, setNav] = useState("home");
  const [goals, setGoals] = useState([]);
  const [circles, setCircles] = useState([]);
  const [myCircles, setMyCircles] = useState([]);
  const [mentorships, setMentorships] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [rewardHistory, setRewardHistory] = useState([]);
  const [leaderboard, setLeaderboard] = useState([]);
  const [toast, setToast] = useState("");
  const [toastType, setToastType] = useState("success");
  const [modalData, setModalData] = useState(null);
  const [selectedGoal, setSelectedGoal] = useState(null);
  const navHistory = useRef([]);

  const showToast = (msg, type = "success") => { setToast(msg); setToastType(type); setTimeout(() => setToast(""), 2500); };
  const goTo = (s, data) => { navHistory.current.push(screen); setScreen(s); if (data) setModalData(data); if (["home", "circles", "mentorship", "rewards", "profile"].includes(s)) setNav(s); };
  const goBack = () => { const prev = navHistory.current.pop() || "home"; setScreen(prev); };

  // ─── PERSISTENCE ───────────────────────────────
  const save = useCallback(async (u, g, c, mc, m, n, rh) => {
    const data = { user: u || user, goals: g || goals, circles: c || circles, myCircles: mc || myCircles, mentorships: m || mentorships, notifications: n || notifications, rewardHistory: rh || rewardHistory };
    await S.set("app-data", data);
  }, [user, goals, circles, myCircles, mentorships, notifications, rewardHistory]);

  useEffect(() => {
    (async () => {
      const data = await S.get("app-data");
      if (data?.user?.name) {
        setUser(data.user);
        setGoals(data.goals || []);
        setCircles(data.circles || getDefaultCircles());
        setMyCircles(data.myCircles || []);
        setMentorships(data.mentorships || []);
        setNotifications(data.notifications || []);
        setRewardHistory(data.rewardHistory || []);
        generateLeaderboard(data.user);
      }
      setLoading(false);
    })();
  }, []);

  const getDefaultCircles = () => [
    { id: "c1", name: "UI/UX Design", members: 12, category: "Design", schedule: "Mon & Thu, 7PM", color: T.blue },
    { id: "c2", name: "Data Analytics", members: 18, category: "Tech", schedule: "Tue & Fri, 6PM", color: T.teal },
    { id: "c3", name: "JAMB 2026 Prep", members: 45, category: "Education", schedule: "Daily, 8AM", color: T.orange },
    { id: "c4", name: "Web Development", members: 34, category: "Tech", schedule: "Wed & Sat, 5PM", color: T.purple },
    { id: "c5", name: "Digital Marketing", members: 28, category: "Business", schedule: "Tue & Thu, 4PM", color: T.green },
    { id: "c6", name: "Product Management", members: 15, category: "Business", schedule: "Mon & Wed, 7PM", color: "#E91E63" },
    { id: "c7", name: "Cybersecurity", members: 9, category: "Tech", schedule: "Fri, 6PM", color: T.red },
    { id: "c8", name: "AI & Machine Learning", members: 22, category: "Tech", schedule: "Sat, 10AM", color: T.dk },
  ];

  const generateLeaderboard = (u) => {
    const names = ["Chukwuemeka O.", "Adaeze N.", "Obioma K.", "Ifeanyi E.", "Ugochi A.", "Nkechi U.", "Emeka D.", "Chidinma I.", "Obinna M.", "Amarachi P."];
    const lb = names.map((n, i) => ({ name: n, pts: 1500 - i * 120, initials: n.split(" ").map(x => x[0]).join(""), location: ["Umuahia", "Aba", "Owerri", "Enugu", "Onitsha"][i % 5] }));
    if (u?.name) lb.push({ name: u.name + " " + (u.username || "").charAt(0) + ".", pts: u.score, initials: u.name.substring(0, 2).toUpperCase(), location: u.location || "Nigeria", isYou: true });
    lb.sort((a, b) => b.pts - a.pts);
    setLeaderboard(lb.map((x, i) => ({ ...x, rank: i + 1 })));
  };

  const updateUser = async (changes) => {
    const updated = { ...user, ...changes, rank: getRank(changes.score ?? user.score) };
    setUser(updated);
    generateLeaderboard(updated);
    await save(updated);
    return updated;
  };

  const addPoints = async (pts, reason) => {
    const u = await updateUser({ score: user.score + pts, totalPoints: user.totalPoints + pts });
    addNotification("⭐", `+${pts} Growth Points`, reason);
    return u;
  };

  const addNotification = (icon, title, desc) => {
    const n = { id: uid(), icon, title, desc, time: new Date().toISOString(), read: false };
    setNotifications(prev => [n, ...prev].slice(0, 50));
  };

  // ─── ONBOARDING SCREEN ─────────────────────────
  if (loading) return <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", background: T.blue }}>
    <div style={{ textAlign: "center", color: "#fff" }}>
      <div style={{ fontSize: 48, fontWeight: 800, color: T.gold, letterSpacing: 2 }}>SkillsCircle</div>
      <p style={{ opacity: 0.7, marginTop: 8 }}>Loading...</p>
    </div>
  </div>;

  if (!user?.name) return <Onboard LS={S} onDone={async (u) => {
    const newUser = { ...DEFAULT_USER, ...u, id: uid(), joined: today() };
    setUser(newUser);
    setCircles(getDefaultCircles());
    generateLeaderboard(newUser);
    await save(newUser, [], getDefaultCircles(), [], [], [], []);
    showToast("Welcome to SkillsCircle! 🎉");
  }} />;

  // ─── RENDER ────────────────────────────────────
  const screens = {
    home: <HomeScreen user={user} goals={goals} myCircles={myCircles} goTo={goTo} notifications={notifications} onCheckIn={async () => {
      if (user.lastCheckIn === today()) { showToast("Already checked in today!", "info"); return; }
      const newStreak = user.lastCheckIn === new Date(Date.now() - 86400000).toISOString().slice(0, 10) ? user.streak + 1 : 1;
      const pts = 10 + (newStreak >= 7 ? 15 : newStreak >= 3 ? 5 : 0);
      const hist = [...(user.checkInHistory || []), today()].slice(-90);
      await updateUser({ lastCheckIn: today(), streak: newStreak, score: user.score + pts, totalPoints: user.totalPoints + pts, checkInHistory: hist });
      addNotification("🔥", `${newStreak}-day streak!`, `+${pts} points for checking in`);
      showToast(`Checked in! 🔥 ${newStreak}-day streak (+${pts} pts)`);
      await save();
    }} />,
    goals: <GoalsScreen goals={goals} goTo={goTo} onAdd={async (g) => {
      const newGoal = { id: uid(), ...g, milestones: g.milestones || [], progress: 0, status: "active", created: today() };
      const updated = [...goals, newGoal];
      setGoals(updated); await save(null, updated); showToast("Goal created! 🎯");
    }} onDelete={async (id) => {
      const updated = goals.filter(g => g.id !== id);
      setGoals(updated); await save(null, updated); showToast("Goal removed");
    }} onSelect={(g) => { setSelectedGoal(g); goTo("progress"); }} />,
    progress: <ProgressScreen goal={selectedGoal} goTo={goTo} goBack={goBack} onUpdateMilestone={async (goalId, msId, status) => {
      const updated = goals.map(g => {
        if (g.id !== goalId) return g;
        const ms = g.milestones.map(m => m.id === msId ? { ...m, status, completedDate: status === "completed" ? today() : null } : m);
        const done = ms.filter(m => m.status === "completed").length;
        const prog = ms.length > 0 ? Math.round((done / ms.length) * 100) : 0;
        const goalStatus = prog === 100 ? "completed" : "active";
        return { ...g, milestones: ms, progress: prog, status: goalStatus };
      });
      setGoals(updated);
      const goal = updated.find(g => g.id === goalId);
      setSelectedGoal(goal);
      if (status === "completed") {
        await addPoints(25, "Milestone completed");
        if (goal.progress === 100) {
          await updateUser({ goalsCompleted: user.goalsCompleted + 1, score: user.score + 25 + 100 });
          addNotification("🏆", "Goal Completed!", `You finished: ${goal.title}`);
          showToast("Goal completed! +100 bonus points! 🏆");
        }
      }
      await save(null, updated);
    }} onAddMilestone={async (goalId, ms) => {
      const updated = goals.map(g => g.id !== goalId ? g : { ...g, milestones: [...g.milestones, { id: uid(), ...ms, status: "pending", completedDate: null }] });
      setGoals(updated);
      setSelectedGoal(updated.find(g => g.id === goalId));
      await save(null, updated);
      showToast("Milestone added");
    }} />,
    circles: <CirclesScreen circles={circles} myCircles={myCircles} goTo={goTo} onJoin={async (circleId) => {
      if (myCircles.includes(circleId)) { showToast("Already joined!", "info"); return; }
      const updated = [...myCircles, circleId];
      setMyCircles(updated);
      await updateUser({ circlesJoined: user.circlesJoined + 1 });
      await addPoints(15, "Joined a new circle");
      await save(null, null, null, updated);
      showToast("Joined circle! +15 pts 🎉");
    }} onLeave={async (circleId) => {
      const updated = myCircles.filter(id => id !== circleId);
      setMyCircles(updated); await save(null, null, null, updated); showToast("Left circle");
    }} />,
    mentorship: <MentorshipScreen user={user} mentorships={mentorships} goTo={goTo} onAdd={async (m) => {
      const updated = [...mentorships, { id: uid(), ...m, created: today(), sessions: 0, hours: 0, status: "active" }];
      setMentorships(updated);
      await updateUser({ peopleMentored: user.peopleMentored + 1 });
      await addPoints(20, m.role === "mentor" ? "Started mentoring someone" : "Found a mentor");
      await save(null, null, null, null, updated);
      showToast(m.role === "mentor" ? "Mentee added! +20 pts" : "Mentor added! +20 pts");
    }} onLogSession={async (id, hours) => {
      const updated = mentorships.map(m => m.id !== id ? m : { ...m, sessions: m.sessions + 1, hours: m.hours + hours, lastSession: today() });
      setMentorships(updated);
      await updateUser({ hoursInvested: user.hoursInvested + hours });
      await addPoints(10 * hours, `Logged ${hours}h mentorship session`);
      await save(null, null, null, null, updated);
      showToast(`Session logged! +${10 * hours} pts`);
    }} onRemove={async (id) => {
      const updated = mentorships.filter(m => m.id !== id);
      setMentorships(updated); await save(null, null, null, null, updated); showToast("Mentorship ended");
    }} />,
    rewards: <RewardsScreen user={user} history={rewardHistory} onRedeem={async (reward) => {
      if (user.totalPoints < reward.cost) { showToast("Not enough points!", "error"); return; }
      await updateUser({ totalPoints: user.totalPoints - reward.cost });
      const updated = [{ id: uid(), reward: reward.name, cost: reward.cost, date: today() }, ...rewardHistory];
      setRewardHistory(updated);
      addNotification("🎁", "Reward Redeemed", `${reward.name} for ${reward.cost} pts`);
      await save(null, null, null, null, null, null, updated);
      showToast(`Redeemed: ${reward.name}! 🎁`);
    }} />,
    leaderboard: <LeaderboardScreen data={leaderboard} goBack={goBack} />,
    opportunities: <OpportunitiesScreen goBack={goBack} />,
    employer: <EmployerScreen goBack={goBack} leaderboard={leaderboard} />,
    studybars: <StudyBarsScreen goBack={goBack} user={user} />,
    notifications: <NotificationsScreen data={notifications} goBack={goBack} onClear={async () => {
      setNotifications([]); await save(null, null, null, null, null, []); showToast("Notifications cleared");
    }} onMarkRead={async () => {
      const updated = notifications.map(n => ({ ...n, read: true }));
      setNotifications(updated); await save(null, null, null, null, null, updated);
    }} />,
    profile: <ProfileScreen user={user} goals={goals} mentorships={mentorships} rewardHistory={rewardHistory} goTo={goTo} onEdit={async (changes) => {
      await updateUser(changes); await save(); showToast("Profile updated");
    }} onReset={async () => {
      await S.del("app-data");
      window.location.reload();
    }} />,
  };

  const unread = notifications.filter(n => !n.read).length;

  return <div style={{ maxWidth: 430, margin: "0 auto", background: T.bg, minHeight: "100vh", display: "flex", flexDirection: "column", fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif", position: "relative" }}>
    <Toast message={toast} type={toastType} />
    <div style={{ flex: 1, overflowY: "auto", paddingBottom: 64 }}>{screens[screen] || screens.home}</div>
    {/* Bottom Nav */}
    <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, display: "flex", justifyContent: "center", zIndex: 100, width: "100%", maxWidth: 430, background: T.white, borderTop: `1px solid ${T.border}`, display: "flex", padding: "6px 0 8px" }}>
      {[
        { icon: I.home, label: "Home", s: "home" },
        { icon: I.search, label: "Circles", s: "circles" },
        { icon: I.users, label: "Mentor", s: "mentorship" },
        { icon: I.star, label: "Rewards", s: "rewards" },
        { icon: I.user, label: "Profile", s: "profile" },
      ].map(({ icon, label, s }) => <button key={s} onClick={() => goTo(s)} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 2, background: "none", border: "none", cursor: "pointer", padding: "4px 0", color: nav === s ? T.blue : T.muted, fontSize: 10, fontWeight: nav === s ? 600 : 400 }}>
        <Icon d={icon} size={20} color={nav === s ? T.blue : T.muted} /><span>{label}</span>
      </button>)}
    </div>
  </div>;
}

// ════════════════════════════════════════════════
// SCREEN COMPONENTS
// ════════════════════════════════════════════════



function HomeScreen({ user, goals, myCircles, goTo, notifications, onCheckIn }) {
  const unread = notifications.filter(n => !n.read).length;
  const checkedIn = user.lastCheckIn === today();
  const activeGoals = goals.filter(g => g.status === "active");

  return <div>
    {/* Hero */}
    <div style={{ background: `linear-gradient(135deg, ${T.blue}, ${T.dk})`, padding: "20px 16px 28px", borderRadius: "0 0 28px 28px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <div>
          <p style={{ color: "rgba(255,255,255,0.6)", margin: 0, fontSize: 13 }}>Welcome back,</p>
          <h1 style={{ margin: "2px 0 0", color: "#fff", fontSize: 22 }}>Hello, {user.name.split(" ")[0]} 👋</h1>
        </div>
        <button onClick={() => goTo("notifications")} style={{ background: "rgba(255,255,255,0.12)", border: "none", borderRadius: "50%", width: 42, height: 42, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", position: "relative" }}>
          <Icon d={I.bell} size={20} color="#fff" />
          {unread > 0 && <span style={{ position: "absolute", top: 4, right: 4, width: 18, height: 18, background: T.orange, borderRadius: "50%", fontSize: 10, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700 }}>{unread}</span>}
        </button>
      </div>
      <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ width: 68, height: 68, borderRadius: "50%", border: `3px solid ${T.gold}`, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span style={{ color: T.gold, fontWeight: 800, fontSize: 22 }}>{user.score}</span>
          </div>
          <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 10, margin: "4px 0 0" }}>{user.rank}</p>
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
            <span style={{ color: "rgba(255,255,255,0.7)", fontSize: 12 }}>Available Points</span>
            <span style={{ color: T.gold, fontSize: 14, fontWeight: 700 }}>{user.totalPoints}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
            <span style={{ color: "rgba(255,255,255,0.7)", fontSize: 12 }}>Streak</span>
            <span style={{ color: "#fff", fontSize: 14, fontWeight: 700 }}>🔥 {user.streak} days</span>
          </div>
          <ProgressBar value={(user.streak / 30) * 100} color={T.gold} h={5} />
        </div>
      </div>
    </div>

    <div style={{ padding: "0 16px" }}>
      {/* Daily Check-in */}
      <Card style={{ marginTop: 16, background: checkedIn ? "#F0FFF4" : "#FFFBEB", border: `1px solid ${checkedIn ? T.green : T.gold}40` }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div>
            <p style={{ margin: 0, fontWeight: 700, fontSize: 15, color: T.dk }}>{checkedIn ? "✅ Checked in today!" : "☀️ Daily Check-in"}</p>
            <p style={{ margin: "2px 0 0", fontSize: 12, color: T.muted }}>{checkedIn ? `${user.streak}-day streak maintained` : "Check in to keep your streak going"}</p>
          </div>
          {!checkedIn && <Btn onClick={onCheckIn} small color={T.gold} style={{ color: T.dk }}>Check In</Btn>}
        </div>
      </Card>

      {/* Active Goals */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: "16px 0 8px" }}>
        <h3 style={{ fontSize: 15, fontWeight: 700, color: T.dk, margin: 0 }}>Active Goals</h3>
        <button onClick={() => goTo("goals")} style={{ background: "none", border: "none", color: T.blue, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>See All</button>
      </div>
      {activeGoals.length === 0 ? <Card onClick={() => goTo("goals")} style={{ textAlign: "center", padding: 24, border: `2px dashed ${T.border}`, background: "transparent", boxShadow: "none" }}>
        <Icon d={I.target} size={28} color={T.muted} />
        <p style={{ margin: "8px 0 0", color: T.muted, fontSize: 14 }}>Set your first goal to get started</p>
      </Card> : activeGoals.slice(0, 2).map(g => <Card key={g.id} onClick={() => { setSelectedGoal(g); goTo("progress"); }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
          <p style={{ margin: 0, fontWeight: 600, fontSize: 14, color: T.dk }}>{g.title}</p>
          <span style={{ fontSize: 13, color: T.blue, fontWeight: 700 }}>{g.progress}%</span>
        </div>
        <ProgressBar value={g.progress} color={T.blue} />
      </Card>)}

      {/* Quick Actions */}
      <h3 style={{ fontSize: 15, fontWeight: 700, color: T.dk, margin: "16px 0 8px" }}>Quick Actions</h3>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 10 }}>
        {[
          { icon: I.target, label: "Goals", s: "goals" }, { icon: I.trending, label: "Leaders", s: "leaderboard" },
          { icon: I.brief, label: "Jobs", s: "opportunities" }, { icon: I.monitor, label: "Study Bars", s: "studybars" },
        ].map(({ icon, label, s }) => <button key={s} onClick={() => goTo(s)} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6, background: T.white, border: `1px solid ${T.border}`, borderRadius: 12, padding: "14px 4px", cursor: "pointer" }}>
          <Icon d={icon} size={20} color={T.blue} /><span style={{ fontSize: 11, color: T.dk, fontWeight: 500 }}>{label}</span>
        </button>)}
      </div>
    </div>
  </div>;
}

function GoalsScreen({ goals, goTo, onAdd, onDelete, onSelect }) {
  const [tab, setTab] = useState("Active");
  const [showAdd, setShowAdd] = useState(false);
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const filtered = goals.filter(g => tab === "Active" ? g.status === "active" : g.status === "completed");

  return <div>
    <Header title="My Goals" right={<Btn onClick={() => setShowAdd(true)} small><Icon d={I.plus} size={14} color="#fff" /> New</Btn>} />
    <TabBar tabs={["Active", "Completed"]} active={tab} onChange={setTab} />
    <div style={{ padding: 16 }}>
      {filtered.length === 0 ? <Empty icon="🎯" title={tab === "Active" ? "No active goals" : "No completed goals"} desc={tab === "Active" ? "Create a goal to start your journey" : "Complete your active goals to see them here"} action={tab === "Active" ? "Create Goal" : null} onAction={() => setShowAdd(true)} /> :
        filtered.map(g => <Card key={g.id} onClick={() => onSelect(g)}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div style={{ flex: 1 }}>
              <p style={{ margin: 0, fontWeight: 600, fontSize: 15, color: T.dk }}>{g.title}</p>
              {g.desc && <p style={{ margin: "4px 0 0", fontSize: 12, color: T.muted }}>{g.desc}</p>}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: 14, color: g.progress === 100 ? T.green : T.blue, fontWeight: 700 }}>{g.progress}%</span>
              <button onClick={(e) => { e.stopPropagation(); onDelete(g.id); }} style={{ background: "none", border: "none", cursor: "pointer", padding: 4 }}><Icon d={I.trash} size={16} color={T.muted} /></button>
            </div>
          </div>
          <div style={{ marginTop: 8 }}><ProgressBar value={g.progress} color={g.progress === 100 ? T.green : T.blue} /></div>
          <p style={{ margin: "6px 0 0", fontSize: 12, color: T.muted }}>{g.milestones.filter(m => m.status === "completed").length}/{g.milestones.length} milestones · Created {fmtDate(g.created)}</p>
        </Card>)}
    </div>
    <Modal open={showAdd} onClose={() => setShowAdd(false)} title="Create New Goal">
      <Input label="Goal Title" value={title} onChange={setTitle} placeholder="e.g. Learn UI/UX Design" />
      <Input label="Description (optional)" value={desc} onChange={setDesc} placeholder="What do you want to achieve?" textarea />
      <Btn full onClick={() => { if (title.trim()) { onAdd({ title: title.trim(), desc: desc.trim(), milestones: [] }); setTitle(""); setDesc(""); setShowAdd(false); } }} disabled={!title.trim()}>Create Goal</Btn>
    </Modal>
  </div>;
}

function ProgressScreen({ goal, goTo, goBack, onUpdateMilestone, onAddMilestone }) {
  const [showAdd, setShowAdd] = useState(false);
  const [msTitle, setMsTitle] = useState("");
  const [msDate, setMsDate] = useState("");

  if (!goal) return <div><Header title="Progress" onBack={goBack} /><Empty icon="📊" title="No goal selected" desc="Go back and select a goal" /></div>;

  const milestones = goal.milestones || [];
  return <div>
    <Header title={goal.title} onBack={goBack} />
    <div style={{ padding: 16 }}>
      <div style={{ textAlign: "center", marginBottom: 20 }}>
        <div style={{ width: 100, height: 100, borderRadius: "50%", border: `4px solid ${goal.progress === 100 ? T.green : T.teal}`, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto", background: T.bg }}>
          <span style={{ fontSize: 28, fontWeight: 800, color: goal.progress === 100 ? T.green : T.teal }}>{goal.progress}%</span>
        </div>
        {goal.progress === 100 && <Badge text="COMPLETED 🎉" color={T.green} />}
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
        <h3 style={{ fontSize: 16, fontWeight: 700, color: T.dk, margin: 0 }}>Milestones ({milestones.length})</h3>
        <Btn onClick={() => setShowAdd(true)} small outline><Icon d={I.plus} size={14} color={T.blue} /> Add</Btn>
      </div>

      {milestones.length === 0 ? <Empty icon="📋" title="No milestones yet" desc="Break your goal into milestones to track progress" action="Add Milestone" onAction={() => setShowAdd(true)} /> :
        milestones.map((m, i) => <div key={m.id} style={{ display: "flex", gap: 12 }}>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <button onClick={() => { if (m.status !== "completed") onUpdateMilestone(goal.id, m.id, "completed"); }} style={{ width: 30, height: 30, borderRadius: "50%", background: m.status === "completed" ? T.green : m.status === "in_progress" ? T.blue : T.border, border: "none", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
              {m.status === "completed" ? <Icon d={I.check} size={14} color="#fff" /> : <span style={{ width: 8, height: 8, borderRadius: "50%", background: m.status === "in_progress" ? "#fff" : "#C4CCD4" }} />}
            </button>
            {i < milestones.length - 1 && <div style={{ width: 2, height: 36, background: m.status === "completed" ? T.green : T.border }} />}
          </div>
          <Card style={{ flex: 1, opacity: m.status === "locked" ? 0.5 : 1, marginBottom: 8 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <p style={{ margin: 0, fontWeight: 600, fontSize: 14, color: T.dk, textDecoration: m.status === "completed" ? "line-through" : "none" }}>{m.title}</p>
                <p style={{ margin: "2px 0 0", fontSize: 12, color: T.muted }}>{m.targetDate ? `Due: ${fmtDate(m.targetDate)}` : ""} {m.completedDate ? `· Done ${fmtDate(m.completedDate)}` : ""}</p>
              </div>
              {m.status !== "completed" && <button onClick={() => onUpdateMilestone(goal.id, m.id, m.status === "in_progress" ? "pending" : "in_progress")} style={{ background: "none", border: "none", cursor: "pointer" }}>
                <Badge text={m.status === "in_progress" ? "Active" : "Start"} color={m.status === "in_progress" ? T.blue : T.muted} />
              </button>}
            </div>
          </Card>
        </div>)}
    </div>
    <Modal open={showAdd} onClose={() => setShowAdd(false)} title="Add Milestone">
      <Input label="Milestone Title" value={msTitle} onChange={setMsTitle} placeholder="e.g. Complete Module 1" />
      <Input label="Target Date (optional)" value={msDate} onChange={setMsDate} type="date" />
      <Btn full onClick={() => { if (msTitle.trim()) { onAddMilestone(goal.id, { title: msTitle.trim(), targetDate: msDate || null }); setMsTitle(""); setMsDate(""); setShowAdd(false); } }} disabled={!msTitle.trim()}>Add Milestone</Btn>
    </Modal>
  </div>;
}

function CirclesScreen({ circles, myCircles, goTo, onJoin, onLeave }) {
  const [search, setSearch] = useState("");
  const [tab, setTab] = useState("Browse");
  const mine = circles.filter(c => myCircles.includes(c.id));
  const browse = circles.filter(c => !myCircles.includes(c.id) && c.name.toLowerCase().includes(search.toLowerCase()));

  return <div>
    <Header title="Skill Circles" />
    <TabBar tabs={["Browse", "My Circles"]} active={tab} onChange={setTab} />
    <div style={{ padding: 16 }}>
      {tab === "Browse" && <>
        <div style={{ display: "flex", alignItems: "center", gap: 8, background: T.white, borderRadius: 10, padding: "10px 14px", marginBottom: 16, border: `1px solid ${T.border}` }}>
          <Icon d={I.search} size={16} color={T.muted} />
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search circles..." style={{ border: "none", background: "none", outline: "none", flex: 1, fontSize: 14 }} />
        </div>
        {browse.map(c => <Card key={c.id}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ width: 44, height: 44, borderRadius: 12, background: c.color, display: "flex", alignItems: "center", justifyContent: "center" }}><Icon d={I.users} size={20} color="#fff" /></div>
            <div style={{ flex: 1 }}>
              <p style={{ margin: 0, fontWeight: 600, fontSize: 14, color: T.dk }}>{c.name}</p>
              <p style={{ margin: "2px 0 0", fontSize: 12, color: T.muted }}>{c.members} members · {c.schedule}</p>
            </div>
            <Btn onClick={() => onJoin(c.id)} small>Join</Btn>
          </div>
        </Card>)}
      </>}
      {tab === "My Circles" && (mine.length === 0 ? <Empty icon="👥" title="No circles yet" desc="Join a circle to learn with peers" action="Browse Circles" onAction={() => setTab("Browse")} /> :
        mine.map(c => <Card key={c.id}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ width: 44, height: 44, borderRadius: 12, background: c.color, display: "flex", alignItems: "center", justifyContent: "center" }}><Icon d={I.users} size={20} color="#fff" /></div>
            <div style={{ flex: 1 }}>
              <p style={{ margin: 0, fontWeight: 600, fontSize: 14, color: T.dk }}>{c.name}</p>
              <p style={{ margin: "2px 0 0", fontSize: 12, color: T.muted }}>{c.schedule}</p>
            </div>
            <Btn onClick={() => onLeave(c.id)} small outline color={T.red}>Leave</Btn>
          </div>
        </Card>))}
    </div>
  </div>;
}

function MentorshipScreen({ user, mentorships, goTo, onAdd, onLogSession, onRemove }) {
  const [tab, setTab] = useState("Mentoring");
  const [showAdd, setShowAdd] = useState(false);
  const [showLog, setShowLog] = useState(null);
  const [newName, setNewName] = useState("");
  const [newSkill, setNewSkill] = useState("");
  const [logHours, setLogHours] = useState("1");
  const mentoring = mentorships.filter(m => m.role === "mentor");
  const beingMentored = mentorships.filter(m => m.role === "mentee");

  return <div>
    <Header title="Mentorship Hub" />
    <TabBar tabs={["Mentoring", "Being Mentored", "Requests"]} active={tab} onChange={setTab} />
    <div style={{ padding: 16 }}>
      {tab === "Mentoring" && <>
        <div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
          <Card style={{ flex: 1, textAlign: "center" }}><p style={{ fontSize: 28, fontWeight: 800, color: T.blue, margin: 0 }}>{user.peopleMentored}</p><p style={{ fontSize: 11, color: T.muted, margin: "4px 0 0" }}>Mentored</p></Card>
          <Card style={{ flex: 1, textAlign: "center" }}><p style={{ fontSize: 28, fontWeight: 800, color: T.teal, margin: 0 }}>{user.hoursInvested}</p><p style={{ fontSize: 11, color: T.muted, margin: "4px 0 0" }}>Hours</p></Card>
        </div>
        {mentoring.map(m => <Card key={m.id}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <Avatar initials={m.name.substring(0, 2).toUpperCase()} size={40} bg={T.blue} />
            <div style={{ flex: 1 }}>
              <p style={{ margin: 0, fontWeight: 600, fontSize: 14, color: T.dk }}>{m.name}</p>
              <p style={{ margin: "2px 0 0", fontSize: 12, color: T.muted }}>{m.skill} · {m.sessions} sessions · {m.hours}h</p>
            </div>
          </div>
          <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
            <Btn onClick={() => setShowLog(m.id)} small full outline>Log Session</Btn>
            <Btn onClick={() => onRemove(m.id)} small color={T.red} style={{ padding: "8px 12px" }}><Icon d={I.x} size={14} color="#fff" /></Btn>
          </div>
        </Card>)}
        <Btn onClick={() => { setShowAdd(true); }} full outline style={{ marginTop: 4 }}><Icon d={I.plus} size={16} color={T.blue} /> Add Mentee</Btn>
      </>}
      {tab === "Being Mentored" && <>
        {beingMentored.length === 0 ? <Empty icon="🤝" title="No mentors yet" desc="Find a mentor to accelerate your learning" action="Find a Mentor" onAction={() => setShowAdd(true)} /> :
          beingMentored.map(m => <Card key={m.id}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <Avatar initials={m.name.substring(0, 2).toUpperCase()} size={40} bg={T.teal} />
              <div style={{ flex: 1 }}>
                <p style={{ margin: 0, fontWeight: 600, fontSize: 14, color: T.dk }}>{m.name}</p>
                <p style={{ margin: "2px 0 0", fontSize: 12, color: T.muted }}>{m.skill} · {m.sessions} sessions</p>
              </div>
              <Btn onClick={() => setShowLog(m.id)} small>Log Session</Btn>
            </div>
          </Card>)}
        <Btn onClick={() => setShowAdd(true)} full outline style={{ marginTop: 4 }}><Icon d={I.plus} size={16} color={T.blue} /> Add Mentor</Btn>
      </>}
      {tab === "Requests" && <Empty icon="📬" title="No pending requests" desc="Mentorship requests will appear here" />}
    </div>
    <Modal open={showAdd} onClose={() => setShowAdd(false)} title={tab === "Mentoring" ? "Add Mentee" : "Add Mentor"}>
      <Input label="Name" value={newName} onChange={setNewName} placeholder="Full name" />
      <Input label="Skill/Topic" value={newSkill} onChange={setNewSkill} placeholder="e.g. Data Analysis" />
      <Btn full onClick={() => { if (newName.trim() && newSkill.trim()) { onAdd({ name: newName.trim(), skill: newSkill.trim(), role: tab === "Mentoring" ? "mentor" : "mentee" }); setNewName(""); setNewSkill(""); setShowAdd(false); } }} disabled={!newName.trim() || !newSkill.trim()}>Add</Btn>
    </Modal>
    <Modal open={!!showLog} onClose={() => setShowLog(null)} title="Log Mentorship Session">
      <Input label="Hours spent" value={logHours} onChange={setLogHours} type="number" placeholder="e.g. 1" />
      <Btn full onClick={() => { onLogSession(showLog, parseFloat(logHours) || 1); setLogHours("1"); setShowLog(null); }}>Log Session</Btn>
    </Modal>
  </div>;
}

function RewardsScreen({ user, history, onRedeem }) {
  const [tab, setTab] = useState("Redeem");
  return <div>
    <Header title="Rewards" />
    <div style={{ padding: 16 }}>
      <Card style={{ background: `linear-gradient(135deg, ${T.blue}, ${T.dk})`, color: "#fff" }}>
        <p style={{ margin: 0, fontSize: 12, opacity: 0.7 }}>Available Balance</p>
        <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "4px 0" }}>
          <span style={{ fontSize: 16 }}>⭐</span>
          <p style={{ margin: 0, fontSize: 36, fontWeight: 800 }}>{user.totalPoints.toLocaleString()}</p>
        </div>
        <p style={{ margin: 0, fontSize: 12, opacity: 0.6 }}>Growth Points · Lifetime earned: {user.score.toLocaleString()}</p>
      </Card>
    </div>
    <TabBar tabs={["Redeem", "History"]} active={tab} onChange={setTab} />
    <div style={{ padding: 16 }}>
      {tab === "Redeem" && REWARDS_CATALOG.map(r => <Card key={r.id}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <span style={{ fontSize: 28 }}>{r.icon}</span>
          <div style={{ flex: 1 }}>
            <p style={{ margin: 0, fontWeight: 600, fontSize: 14, color: T.dk }}>{r.name}</p>
            <p style={{ margin: "2px 0 0", fontSize: 12, color: T.muted }}>{r.cost.toLocaleString()} points</p>
          </div>
          <Btn onClick={() => onRedeem(r)} small disabled={user.totalPoints < r.cost} color={user.totalPoints >= r.cost ? T.teal : T.muted}>Redeem</Btn>
        </div>
      </Card>)}
      {tab === "History" && (history.length === 0 ? <Empty icon="🎁" title="No redemptions yet" desc="Redeem your points for rewards" /> :
        history.map(h => <Card key={h.id}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div><p style={{ margin: 0, fontWeight: 600, fontSize: 14, color: T.dk }}>{h.reward}</p><p style={{ margin: "2px 0 0", fontSize: 12, color: T.muted }}>{fmtDate(h.date)}</p></div>
            <span style={{ color: T.red, fontWeight: 700, fontSize: 14 }}>-{h.cost}</span>
          </div>
        </Card>))}
    </div>
  </div>;
}

function LeaderboardScreen({ data, goBack }) {
  const [tab, setTab] = useState("This Week");
  const top3 = data.slice(0, 3);
  const rest = data.slice(3);
  const podiumOrder = top3.length >= 3 ? [top3[1], top3[0], top3[2]] : top3;

  return <div>
    <Header title="Leaderboard" onBack={goBack} />
    <TabBar tabs={["This Week", "This Month", "All Time"]} active={tab} onChange={setTab} />
    <div style={{ padding: 16 }}>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-end", gap: 10, marginBottom: 20, paddingTop: 12 }}>
        {podiumOrder.map((p, i) => {
          const heights = [72, 92, 60]; const sizes = [44, 52, 40]; const colors = [T.muted, T.gold, "#CD7F32"];
          return <div key={p.rank} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
            <Avatar initials={p.initials} size={sizes[i]} bg={colors[i]} />
            <p style={{ margin: 0, fontWeight: 700, fontSize: 12, color: T.dk, textAlign: "center" }}>{p.name}{p.isYou ? " (You)" : ""}</p>
            <p style={{ margin: 0, fontSize: 11, color: T.muted }}>{p.pts.toLocaleString()}</p>
            <div style={{ width: 60, height: heights[i], background: i === 1 ? T.blue : T.bg, borderRadius: "8px 8px 0 0", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span style={{ fontSize: 18, fontWeight: 800, color: i === 1 ? "#fff" : T.dk }}>{p.rank}</span>
            </div>
          </div>;
        })}
      </div>
      {rest.map(p => <Card key={p.rank}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <span style={{ width: 24, textAlign: "center", fontWeight: 700, color: T.muted }}>{p.rank}</span>
          <Avatar initials={p.initials} size={36} bg={T.blue} />
          <div style={{ flex: 1 }}><p style={{ margin: 0, fontWeight: 600, fontSize: 14, color: T.dk }}>{p.name}{p.isYou ? " (You)" : ""}</p><p style={{ margin: 0, fontSize: 12, color: T.muted }}>{p.location}</p></div>
          <span style={{ fontWeight: 700, color: T.blue, fontSize: 14 }}>{p.pts.toLocaleString()}</span>
        </div>
      </Card>)}
    </div>
  </div>;
}

function OpportunitiesScreen({ goBack }) {
  const [tab, setTab] = useState("All");
  const [saved, setSaved] = useState([]);
  const filtered = tab === "All" ? SAMPLE_OPPORTUNITIES : SAMPLE_OPPORTUNITIES.filter(o => o.type === tab);

  return <div>
    <Header title="Opportunities" onBack={goBack} />
    <TabBar tabs={["All", "Internship", "Job", "Scholarship"]} active={tab} onChange={setTab} />
    <div style={{ padding: 16 }}>
      {filtered.map(o => <Card key={o.id}>
        <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
          <Avatar initials={o.company.substring(0, 2).toUpperCase()} size={42} bg={T.teal} />
          <div style={{ flex: 1 }}>
            <p style={{ margin: 0, fontWeight: 600, fontSize: 15, color: T.dk }}>{o.title}</p>
            <p style={{ margin: "3px 0 0", fontSize: 13, color: T.muted }}>{o.company} · {o.location}</p>
            <div style={{ display: "flex", gap: 6, marginTop: 6 }}>
              <Badge text={o.type} color={o.type === "Internship" ? T.blue : o.type === "Job" ? T.teal : T.purple} />
              {new Date(o.posted) > new Date(Date.now() - 3 * 86400000) && <Badge text="New" color={T.orange} />}
            </div>
          </div>
          <button onClick={() => setSaved(s => s.includes(o.id) ? s.filter(x => x !== o.id) : [...s, o.id])} style={{ background: "none", border: "none", cursor: "pointer", padding: 4 }}>
            <Icon d={saved.includes(o.id) ? I.heart : I.heart} size={18} color={saved.includes(o.id) ? T.red : T.muted} />
          </button>
        </div>
      </Card>)}
    </div>
  </div>;
}

function EmployerScreen({ goBack, leaderboard }) {
  const [search, setSearch] = useState("");
  const candidates = leaderboard.filter(l => l.name.toLowerCase().includes(search.toLowerCase())).slice(0, 8);

  return <div>
    <Header title="Employer Marketplace" onBack={goBack} />
    <div style={{ padding: 16 }}>
      <p style={{ color: T.muted, fontSize: 13, margin: "0 0 12px" }}>Discover top talent with verified growth records.</p>
      <div style={{ display: "flex", alignItems: "center", gap: 8, background: T.white, borderRadius: 10, padding: "10px 14px", marginBottom: 16, border: `1px solid ${T.border}` }}>
        <Icon d={I.search} size={16} color={T.muted} />
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search candidates..." style={{ border: "none", background: "none", outline: "none", flex: 1, fontSize: 14 }} />
      </div>
      {candidates.map(c => <Card key={c.rank}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <Avatar initials={c.initials} size={42} bg={T.blue} />
          <div style={{ flex: 1 }}>
            <p style={{ margin: 0, fontWeight: 600, fontSize: 14, color: T.dk }}>{c.name}</p>
            <p style={{ margin: "2px 0 0", fontSize: 12, color: T.muted }}>{c.location}</p>
            <p style={{ margin: "2px 0 0", fontSize: 12, color: T.teal, fontWeight: 600 }}>Score: {c.pts} · Rank #{c.rank}</p>
          </div>
          <Btn small>View</Btn>
        </div>
      </Card>)}
      <Btn full color={T.teal} style={{ marginTop: 8 }}>Post a Job</Btn>
    </div>
  </div>;
}

function StudyBarsScreen({ goBack, user }) {
  return <div>
    <Header title="Study Bars" onBack={goBack} />
    <div style={{ padding: 16 }}>
      <Card style={{ background: `linear-gradient(135deg, ${T.teal}, ${T.blue})`, color: "#fff" }}>
        <p style={{ margin: 0, fontWeight: 700, fontSize: 16 }}>⭐ Your Study Bar Pass</p>
        <p style={{ margin: "4px 0 0", fontSize: 13, opacity: 0.8 }}>Redeem Growth Points for access</p>
        <p style={{ margin: "8px 0 0", fontSize: 12, opacity: 0.7 }}>Available points: {user.totalPoints.toLocaleString()}</p>
      </Card>
      <h3 style={{ fontSize: 15, fontWeight: 700, color: T.dk, margin: "16px 0 10px" }}>Nearby Study Bars</h3>
      {SAMPLE_STUDY_BARS.map(s => <Card key={s.id}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ width: 48, height: 48, borderRadius: 12, background: T.bg, display: "flex", alignItems: "center", justifyContent: "center" }}><Icon d={I.monitor} size={22} color={T.blue} /></div>
          <div style={{ flex: 1 }}>
            <p style={{ margin: 0, fontWeight: 600, fontSize: 14, color: T.dk }}>{s.name}</p>
            <p style={{ margin: "2px 0 0", fontSize: 12, color: T.muted }}>{s.access} · {s.distance}</p>
            <div style={{ display: "flex", gap: 4, marginTop: 4 }}>{s.amenities.map(a => <span key={a} style={{ fontSize: 10, background: T.bg, padding: "2px 6px", borderRadius: 6, color: T.muted }}>{a}</span>)}</div>
          </div>
          <Icon d={I.chevR} size={16} color={T.muted} />
        </div>
      </Card>)}
    </div>
  </div>;
}

function NotificationsScreen({ data, goBack, onClear, onMarkRead }) {
  useEffect(() => { onMarkRead(); }, []);
  return <div>
    <Header title="Notifications" onBack={goBack} right={data.length > 0 && <button onClick={onClear} style={{ background: "none", border: "none", color: T.red, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>Clear All</button>} />
    <div style={{ padding: 16 }}>
      {data.length === 0 ? <Empty icon="🔔" title="No notifications" desc="You're all caught up!" /> :
        data.map(n => <Card key={n.id} style={{ opacity: n.read ? 0.7 : 1 }}>
          <div style={{ display: "flex", gap: 12 }}>
            <span style={{ fontSize: 24 }}>{n.icon}</span>
            <div style={{ flex: 1 }}>
              <p style={{ margin: 0, fontWeight: 600, fontSize: 14, color: T.dk }}>{n.title}</p>
              <p style={{ margin: "2px 0 0", fontSize: 12, color: T.muted }}>{n.desc}</p>
            </div>
            <span style={{ fontSize: 11, color: T.muted, whiteSpace: "nowrap" }}>{fmtDate(n.time)}</span>
          </div>
        </Card>)}
    </div>
  </div>;
}

function ProfileScreen({ user, goals, mentorships, rewardHistory, goTo, onEdit, onReset }) {
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(user.name);
  const [location, setLocation] = useState(user.location);
  const [newSkill, setNewSkill] = useState("");

  return <div>
    <div style={{ background: `linear-gradient(135deg, ${T.blue}, ${T.dk})`, padding: "28px 16px", textAlign: "center" }}>
      <Avatar initials={user.name.substring(0, 2).toUpperCase()} size={76} bg="rgba(255,255,255,0.15)" />
      <h2 style={{ color: "#fff", margin: "10px 0 2px", fontSize: 22 }}>{user.name}</h2>
      <p style={{ color: "rgba(255,255,255,0.6)", margin: 0, fontSize: 13 }}>{user.username}</p>
      <p style={{ color: "rgba(255,255,255,0.5)", margin: "4px 0 12px", fontSize: 12 }}>{user.location}</p>
      <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(255,255,255,0.1)", padding: "8px 20px", borderRadius: 20 }}>
        <span style={{ color: T.gold, fontWeight: 800, fontSize: 22 }}>{user.score}</span>
        <span style={{ color: "rgba(255,255,255,0.6)", fontSize: 13 }}>{user.rank}</span>
      </div>
    </div>
    <div style={{ padding: 16 }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 8, marginBottom: 16 }}>
        {[{ n: user.goalsCompleted, l: "Goals" }, { n: user.circlesJoined, l: "Circles" }, { n: user.peopleMentored, l: "Mentored" }, { n: user.streak, l: "Streak" }].map(s =>
          <Card key={s.l} style={{ textAlign: "center", padding: 10 }}>
            <p style={{ fontSize: 22, fontWeight: 800, color: T.blue, margin: 0 }}>{s.n}</p>
            <p style={{ fontSize: 10, color: T.muted, margin: "2px 0 0" }}>{s.l}</p>
          </Card>)}
      </div>

      <h3 style={{ fontSize: 14, fontWeight: 700, color: T.dk, margin: "0 0 8px" }}>Skills</h3>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 16 }}>
        {(user.skills || []).map(s => <span key={s} style={{ background: T.bg, padding: "6px 12px", borderRadius: 20, fontSize: 12, color: T.dk, fontWeight: 500 }}>{s}</span>)}
      </div>

      <h3 style={{ fontSize: 14, fontWeight: 700, color: T.dk, margin: "0 0 8px" }}>Member Since</h3>
      <p style={{ fontSize: 13, color: T.muted, margin: "0 0 16px" }}>{fmtDate(user.joined)}</p>

      <Btn full outline onClick={() => setEditing(true)} style={{ marginBottom: 8 }}><Icon d={I.edit} size={16} color={T.blue} /> Edit Profile</Btn>
      <Btn full outline color={T.red} onClick={() => { if (confirm("Reset all data? This cannot be undone.")) onReset(); }}>Reset Account</Btn>
    </div>
    <Modal open={editing} onClose={() => setEditing(false)} title="Edit Profile">
      <Input label="Name" value={name} onChange={setName} />
      <Input label="Location" value={location} onChange={setLocation} />
      <Input label="Add a Skill" value={newSkill} onChange={setNewSkill} placeholder="e.g. Python" />
      {newSkill.trim() && <Btn small outline onClick={() => { onEdit({ skills: [...(user.skills || []), newSkill.trim()] }); setNewSkill(""); }} style={{ marginBottom: 12 }}>+ Add "{newSkill.trim()}"</Btn>}
      <Btn full onClick={() => { onEdit({ name: name.trim() || user.name, location: location.trim() || user.location }); setEditing(false); }}>Save Changes</Btn>
    </Modal>
  </div>;
}
